import React from "react"
import { useTranslation } from "next-i18next"
import { QRCode as Qr } from "react-qr-code"
import Style from "@/components/VisualSearch/v1/QRCode/index.module.scss"
import { getTranslations } from "@/components/VisualSearch/localization"
import Button from "@/components/core/Button/Button"
import { showMedalliaFeedbackModal } from "@/services/medallia"
import { MEDALLIA_FORM_ID } from "@/components/InPageSearch/v1/utils"

const QRCode = () => {
  const baseUrl = window.location.href
  const currentUrl = `${baseUrl}#search`
  const { t } = useTranslation()
  const { QRCodeText, helpText, feedbackText } = getTranslations(t)

  return (
    <div className={`${Style.QRCodeWrapper}`}>
      <div className="qr-feedback visualContentwarpper">
        <div className="qr-section">
          <div className="qr-part">
            <Qr size={82.93} value={currentUrl} />
          </div>
          <p className="photo_label">{QRCodeText}</p>
        </div>
        <div className="provide-feedback">
          <div className="feedback">
            <p>{helpText}</p>
            <Button
              className="provide-feedback-button"
              type="ghost"
              label={feedbackText}
              size="large"
              flexible={true}
              onClick={() => showMedalliaFeedbackModal(MEDALLIA_FORM_ID)}
              role="button"
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default QRCode
